import { DensityUnitEnum, DimensionUnitEnum, MaterialStorageType, PackedOnEnum, StrappingEnum } from 'api';
import { MaterialComponentValueSchema } from 'features';
import { type InferType, yup } from 'form';

import { UploadGenericDocumentSchema } from '~/document/schema';

export const BuyerMaterialSpecificationSchema = yup.object({
  buyer_id: yup.number().required(),
  document: yup.mixed<InferType<typeof UploadGenericDocumentSchema>>().test('document', 'Invalid document', (value) => {
    if (value === undefined || value === null) {
      return true;
    }
    try {
      UploadGenericDocumentSchema.validateSync(value);
      return true;
    } catch (error) {
      return false;
    }
  }),
  file_url: yup.string().optional(),
  material_colour_id: yup.number().optional(),
  material_form_id: yup.number().required(),
  material_grade_id: yup.number().required(),
  material_id: yup.number().required(),
  material_qualities: yup
    .array()
    .of(MaterialComponentValueSchema)
    .required()
    .min(1, 'At least one material component is required'),
  notes: yup.string().optional(),
  packaging_specification_ids: yup.array().of(yup.number().required()).required(),
});

export type BuyerMaterialSpecificationFormType = InferType<typeof BuyerMaterialSpecificationSchema>;

export const PackagingSpecificationSchema = yup.object({
  density_unit: yup.string().oneOf(Object.values(DensityUnitEnum)).required(),
  dimension_unit: yup.string().oneOf(Object.values(DimensionUnitEnum)).required(),
  max_density: yup.number().emptyAsUndefined().optional(),
  max_height: yup.number().emptyAsUndefined().optional(),
  max_length: yup.number().emptyAsUndefined().optional(),
  max_load_weight: yup.number().emptyAsUndefined().optional(),
  max_weight: yup.number().emptyAsUndefined().optional(),
  max_width: yup.number().emptyAsUndefined().optional(),
  min_density: yup.number().emptyAsUndefined().optional(),
  min_height: yup.number().emptyAsUndefined().optional(),
  min_length: yup.number().emptyAsUndefined().optional(),
  min_load_weight: yup.number().emptyAsUndefined().optional(),
  min_weight: yup.number().emptyAsUndefined().optional(),
  min_width: yup.number().emptyAsUndefined().optional(),
  packed_on: yup.string().oneOf(Object.values(PackedOnEnum)).optional(),
  storage_type: yup.string().oneOf(Object.values(MaterialStorageType)).required(),
  strapping: yup
    .array()
    .of(yup.string().oneOf(Object.values(StrappingEnum)).required())
    .required(),
  title: yup.string().optional(),
});

export type PackagingSpecificationType = InferType<typeof PackagingSpecificationSchema>;
